import React from "react";
import { Box, Typography, Card, CardContent, CardActionArea, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import AssignmentIcon from '@mui/icons-material/Assignment';

const BuyerSelection = () => {
    const navigate = useNavigate();

    return (
        <Box sx={{ height: "100vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", bgcolor: "#f5f5f5" }}>
            <Typography variant="h4" mb={5} fontWeight="bold">Choose Dashboard</Typography>
            <Grid container spacing={4} justifyContent="center" sx={{ maxWidth: 800 }}>
                <Grid item xs={12} sm={6}>
                    <Card sx={{ borderRadius: "15px" }}>
                        <CardActionArea onClick={() => navigate("/dashboard")} sx={{ p: 5, textAlign: 'center' }}>
                            <AssignmentIcon sx={{ fontSize: 60, color: "#1976d2" }} />
                            <Typography variant="h5" mt={2} textTransform={"none"}>eRFQ</Typography>
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Card sx={{ borderRadius: "15px" }}>
                        <CardActionArea onClick={() => navigate("/logistic-dashboard")} sx={{ p: 5, textAlign: 'center' }}>
                            <DirectionsBoatIcon sx={{ fontSize: 60, color: "#2e7d32" }} />
                            <Typography variant="h5" mt={2}>Logistics RFQ</Typography>
                        </CardActionArea>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    );
};
export default BuyerSelection;

